import { useEffect, useState } from "react";
import { Section1, Section2, Section3, Section4, owl } from "../assets/images/image";

const Home = () => {
    const [index, setIndex] = useState(0);
    const slides = [
        {
            id: 1,
            fragment: `  
             <div class="md:mt-0 mt-[10%]" data-reveal="up">
                <div class="md:space-y-4 space-y-2">
                    <div class="absolute bottom-0 mb-10 left-1/3 md:sticky space-y-2 flex flex-col md:text-left text-center md:items-start items-center hidden md:flex">
                        <img src="${owl}" class="md:w-[47px] md:h-[47px] w-[32px]"/>
                        <p class="md:text-[17px] text-[11px] font-inter font-light text-[#212224]">Personalized <br/> learning, naturally</p>
                    </div>
                    <p class="md:text-[48px] text-[24px] font-inter font-light text-[#484848]">Learn Smarter</p>
                    <p class="md:text-[48px] text-[24px] font-inter font-bold text-[#484848]">Not <span class="md:text-[48px] text-[24px] font-inter font-bold text-[#FFD600]"> Harder</span></p>
                    <p class="md:text-[17px] text-[14px] font-inter text-[#484848]"><span class="font-semibold">AI-Powered Flashcards</span> for Every Subject</p>
                    <p class="md:text-[17px] text-[14px] font-inter text-[#484848]"><span class="font-semibold">Effortless Flashcard</span> Creation with AI</p>
                    <p class="md:text-[17px] text-[14px] font-inter text-[#484848]">Personalized Learning</p>
                    <p class="md:text-[17px] text-[14px] font-inter text-[#484848]">Diverse Content Support</p>
                    <p class="md:text-[17px] text-[14px] font-inter text-[#484848]">Spaced Repetition</p>
                </div>
            </div>`,
            image: Section1
        },
        {
            id: 2,
            fragment: `
            <div class="md:mt-0 mt-[10%]" data-reveal="up"> 
                <div class="md:space-y-4 space-y-2">
                    <div class="flex items-center justify-center md:w-12 w-8 md:h-12 h-8 rounded-lg bg-[#FFD600] shadow-owl">
                        <img src="${owl}" class="md:w-8 w-5 md:h-8 h-5"/>
                    </div>
                   <div>
                    <p class="md:text-[48px] text-[24px] font-inter font-bold text-[#484848]">AI-Powered </p>
                    <p class="md:text-[17px] text-[14px] font-inter font-light text-[#484848]">Flashcards for Every Subject</p>
                   </div>
                </div>
            </div>`,
            image: Section2
        },
        {
            id: 3,
            fragment: `
                <div class="md:space-y-4 space-y-2" data-reveal="up">
                    <div>
                        <p class="md:text-[48px] text-[24px] font-inter font-bold text-[#484848]">Effortless</p>
                        <p class="md:text-[48px] text-[24px] font-inter font-bold text-[#FFD600]">Learning</p>
                    </div>
                    <p class="md:text-[17px] text-[14px] font-inter text-[#484848]">Effortless Flashcard Creation with AI</p>
                </div>
                `,
            image: Section3
        },
        {
            id: 4,
            fragment: `
                <div class="md:space-y-4 space-y-2" data-reveal="up">
                    <div>
                        <p class="md:text-[48px] text-[24px] font-inter font-bold text-[#FFD600]">Personalized</p>
                        <p class="md:text-[48px] text-[24px] font-inter font-bold text-[#484848]">Learning</p>
                    </div>
                    <p class="md:text-[17px] text-[14px] font-inter text-[#484848]">We transform your short-term </br/> memory into long-term knowledge.</p>
                </div>
                `,
            image: Section4
        },
    ];
    const [isClicked, setIsClicked] = useState(false);

    useEffect(() => {
        if (isClicked) return;
        const interval = setInterval(() => {
            setIndex(prevIndex => (prevIndex + 1) % slides.length);
        }, 3500);

        return () => clearInterval(interval);
    }, [isClicked, slides.length]);
    const handleItemClick = (index: number) => {
        setIndex(index);
        setIsClicked(true);
    };
    return (
        <div className="relative w-full h-[calc(100vh-74.5px)] overflow-hidden mx-auto">
            <div className="flex flex-col md:flex-row items-center justify-center w-full h-full px-6 md:px-[100px]">
                <div className="md:w-[50%] w-full max-h-[600px] md:h-full h-auto relative" data-parallax="0.14">
                    {slides.map((val: any, i: number) => (
                        <div
                            key={val.id || i}
                            className={`absolute w-full md:h-full h-[200px] rounded-tl-[16px] overflow-hidden flex items-end justify-end transition-all duration-1000 ease-in-out ${i === index ? "opacity-100 z-10" : "opacity-0 z-0"
                                }`}
                        >
                            <img
                                src={val.image}
                                alt={`Slide ${i + 1}`}
                                className="w-full h-full"
                            />
                        </div>
                    ))}
                </div>
                <div className="md:w-[50%] w-full h-full transition-opacity duration-700 ease-in-out">
                    <div
                        key={slides[index]?.id ?? index}
                        className="w-full h-full flex items-center md:justify-center justify-left"
                        dangerouslySetInnerHTML={{ __html: slides[index]?.fragment ?? "" }}
                    />
                </div>
            </div>
            <div className="absolute flex items-center gap-4 px-4 md:bottom-[50px] bottom-[20%] w-[60%] justify-between w-full" data-reveal="up">
                <div className="flex gap-4 items-end md:px-0 px-5">
                    <div className="flex items-end gap-4">
                        <div className="relative w-[66px] h-[58px]">
                            {slides.map((val: any, i: any) => {
                                return (
                                    <p key={i} className={`text-[48px] absolute font-bold font-inter text-[#484848] transition-all duration-1000 ease-in-out ${i === index ? "opacity-100 z-10" : "opacity-0 z-0"}`}>0{i + 1}</p>
                                )
                            })}
                        </div>
                        <p className="text-[24px] text-[#D9D9D9] font-inter font-normal"><span className="font-bold">/</span>04</p  >
                    </div>
                    <div className="flex items-center gap-4 absolute bottom-0 right-10 md:sticky">
                        {slides.map((val: any, i: any) => {
                            return (
                                <div key={i} className={`cursor-pointer rounded-full ${i === index ? "w-8 h-8 bg-[#FFD600] border border-[#D9D9D9]" : "w-4 h-4 bg-[#D9D9D9] border border-[#484848]"}`} onClick={() => { handleItemClick(i) }}>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>

    );
}
export default Home;